<template>
  <a-spin :spinning="saveLoading">
    <div class="account-settings-info-view">
      <a-row :gutter="16">
        <a-col :md="24" :lg="16">
          <a-form layout="vertical" :form="form">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结算类型" hasFeedback>
              <a-radio-group  v-model="formData.cash_type">
                <a-radio   :value="1">银行</a-radio>
                <!--<a-radio   :value="2">微信(自动结算)</a-radio>-->
              </a-radio-group>
            </a-form-item>

            <a-form-item label="账户名称" v-show="formData.cash_type==1">
              <a-input
                placeholder="请输入开户账户名称"
                v-decorator="[
          'cash_name',
          {rules: [{ required: true, message: '请输入开户账户名称' }]}
        ]"
              />
            </a-form-item>
            <a-form-item label="开户银行" v-show="formData.cash_type==1">
              <a-input
                placeholder="请输入开户银行"
                v-decorator="[
            'cash_bank',
            {rules: [{ required: true, message: '请输入开户开户银行' }]}
            ]"
              />
            </a-form-item>

            <a-form-item label="银行账号" v-show="formData.cash_type==1">
              <a-input
                placeholder="请输入银行账号"
                v-decorator="[
          'cash_code',
          {rules: [{ required: true, message: '请输入银行账号' }]}
        ]"
              />
            </a-form-item>

            <a-form-item label="选择微信用户" v-show="formData.cash_type==2">
              <user-picker :formData="formData" field="cash_weixin_user_id" />
            </a-form-item>
            <a-form-item v-show="formData.cash_type==2">
              <a-button type="primary"  :loading="saveLoading" @click="submitWxForm">保存</a-button>
            </a-form-item>
            <a-form-item v-show="formData.cash_type==1">
              <a-button type="primary"   :loading="saveLoading" @click="submitForm">保存</a-button>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :md="24" v-if="false" :lg="8" :style="{ minHeight: '180px' }">
          <div class="ant-upload-preview" @click="$refs.modal.edit(1)">
            <a-icon type="cloud-upload-o" class="upload-icon" />
            <div class="mask">
              <a-icon type="plus" />
            </div>
            <img :src="option.img" />
          </div>
        </a-col>
      </a-row>
    </div>
  </a-spin>
</template>

<script>
import { wyhSetting,getWyhSetting } from '@/api/wyh'
import RSwitch from '@/components/RSwitch/'
import PicUploader from '@/components/PicUploader/'
import UserPicker from '@/components/UserPicker/'
export default {
  components: {
    PicUploader,
    RSwitch,
    UserPicker
  },
  data() {
    return {
      // cropper
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      saveLoading: false,
      form: this.$form.createForm(this),
      preview: {},
      option: {
        img: '/avatar2.jpg',
        info: true,
        size: 1,
        outputType: 'jpeg',
        canScale: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 180,
        autoCropHeight: 180,
        fixedBox: true,
        // 开启宽度和高度比例
        fixed: true,
        fixedNumber: [1, 1]
      },
      formData: {
        cash_bank: '',
        cash_code: '',
        cash_name: '',
        cash_type: 1,
        cash_weixin_user_id:undefined,
      }
    }
  },
  mounted() {
    let that = this
    that.fetch()
  },
  methods: {
    fetch() {
      let that = this
      getWyhSetting({})
        .then(res => {
          that.formData = res.data
          that.form.setFieldsValue({ ...res.data })
        })
        .catch(err => {})
    },

    submitForm(e) {
      let self = this
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          self.saveLoading = true
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          wyhSetting(Object.assign(self.formData, values))
            .then(res => {
              self.$message.success('设置成功')
              self.saveLoading = false
            })
            .catch(err => {
              self.$message.error(err.data.msg)
              self.saveLoading = false
            })
        } else {
          console.log(err)
        }
      })
    },
    submitWxForm(e) {
      let self = this    
          console.log()
          console.log('Received valuess of formData: ', self.formData)
        wyhSetting(self.formData)
            .then(res => {
              self.$message.success('设置成功')
              self.saveLoading = false
            })
            .catch(err => {
              self.$message.error(err.data.msg)
              self.saveLoading = false
            })
         
      }
    
  }
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>